import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getInitials(name: string | null | undefined): string {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length > 1 && parts[0] && parts[parts.length - 1]) {
    const firstPart = parts[0];
    const lastPart = parts[parts.length - 1];
    if (firstPart[0] && lastPart[0]) {
      return `${firstPart[0]}${lastPart[0]}`.toUpperCase();
    }
  }
  return name[0]?.toUpperCase() || "";
}

